import { Box, Link as ChakraLink, Text, VStack } from "@chakra-ui/react";
import { sections } from "../data/sections";
import { useActiveSection } from "../hooks/useActiveSection";

const sectionIds = sections.map((s) => s.id);

export function ChapterRail() {
  const activeId = useActiveSection(sectionIds);

  return (
    <Box
      as="nav"
      aria-label="Capítulos da página"
      position="fixed"
      right="18px"
      top="50%"
      transform="translateY(-50%)"
      zIndex={40}
      display="none"
      sx={{ "@media (min-width: 1400px)": { display: "block" } }}
    >
      <VStack align="flex-end" spacing={1}>
        {sections.map((section, i) => {
          const isActive = section.id === activeId;
          return (
            <ChakraLink
              key={section.id}
              href={`#${section.id}`}
              role="group"
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              gap={2}
              h="22px"
              _hover={{ textDecoration: "none" }}
              aria-current={isActive ? "true" : undefined}
            >
              <Text
                as="span"
                fontFamily="mono"
                fontSize="10px"
                letterSpacing="0.12em"
                textTransform="uppercase"
                whiteSpace="nowrap"
                color={isActive ? "accent.300" : "graphite.300"}
                opacity={0}
                transform="translateX(6px)"
                transition="opacity 0.25s ease, transform 0.25s ease"
                _groupHover={{ opacity: 1, transform: "translateX(0)" }}
                _groupFocusVisible={{ opacity: 1, transform: "translateX(0)" }}
              >
                {section.label}
              </Text>
              <Text
                as="span"
                fontFamily="mono"
                fontSize="10px"
                color="accent.300"
                opacity={isActive ? 1 : 0}
                transition="opacity 0.3s ease"
                aria-hidden
              >
                {String(i + 1).padStart(2, "0")}
              </Text>
              <Box
                h="2px"
                borderRadius="full"
                w={isActive ? "26px" : "12px"}
                bg={isActive ? "accent.400" : "whiteAlpha.400"}
                transition="width 0.35s cubic-bezier(0.22, 1, 0.36, 1), background-color 0.35s ease"
                _groupHover={{ bg: "accent.300" }}
              />
            </ChakraLink>
          );
        })}
      </VStack>
    </Box>
  );
}
